// Drill-down breadcrumb. Dumb renderer over the page-owned trail of
// {type, label, payload}; clicking a segment truncates everything
// past it via onJumpToIndex (segment 0 closes all drilldowns).

import React from 'react'
import classNames from 'classnames'
import { isEmpty } from 'lodash'
import { IconChevronRight, IconHome } from '@tabler/icons-react'

const ENTRY_KINDS = {
  agent: { kind: 'agent', label: 'Agent' },
  criterion: { kind: 'criterion', label: 'Criterion' },
  scorecard: { kind: 'scorecard', label: 'Scorecard' },
  'browse-calls': { kind: 'browse', label: 'Calls' },
}

export const NavTrail = ({ entries = [], onJumpToIndex }) => {
  // Hide entirely when there's nothing to navigate back to.
  if (!Array.isArray(entries) || isEmpty(entries)) {
    return null
  }
  return (
    <nav className="nav-trail" aria-label="Drilldown path">
      <button
        type="button"
        className="nav-trail-segment nav-trail-root"
        onClick={() => onJumpToIndex(-1)}
        title="Back to the dashboard"
      >
        <IconHome size={12} />
        <span>Dashboard</span>
      </button>
      {entries.map((entry, idx) => {
        const meta = ENTRY_KINDS[entry.type] || { kind: 'other', label: entry.type }
        const isLast = idx === entries.length - 1
        return (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`${entry.type}-${idx}-${entry.label}`}>
            <IconChevronRight size={12} className="nav-trail-sep" />
            <button
              type="button"
              className={classNames('nav-trail-segment', `nav-trail-${meta.kind}`, {
                'is-current': isLast,
              })}
              onClick={() => onJumpToIndex(idx)}
              title={
                isLast
                  ? `${meta.label}: ${entry.label}`
                  : `Back to ${meta.label.toLowerCase()}: ${entry.label}`
              }
            >
              <span className="nav-trail-kind">{meta.label}</span>
              <span className="nav-trail-label">{entry.label}</span>
            </button>
          </React.Fragment>
        )
      })}
    </nav>
  )
}
